import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import Marquee from '../../components/ui/Marquee';
import useGsap from '../../motion/useGsap';
import { prefersReducedMotion } from '../../motion/tokens';

const TEXT =
  'One team scopes, designs, builds and keeps it running. Prices are on the page, half is due up front, and the code is yours from day one. No handoffs, no surprises.';

const OWN = [
  { name: 'BluBeds', to: '/work/blubeds' },
  { name: 'Nighthouse', to: '/work/nighthouse' },
  { name: 'Postify', href: 'https://postify.social' },
  { name: 'FillAI', href: 'https://fillai.postify.social' },
  { name: 'ValidMy.email', to: '/work/validmyemail' },
];

// Word-by-word scrub: the paragraph lights up as you read down it.
export default function Manifesto() {
  const ref = useRef(null);
  useGsap(ref, (gsap) => {
    if (prefersReducedMotion()) return;
    gsap.fromTo(
      ref.current.querySelectorAll('[data-word]'),
      { opacity: 0.18 },
      { opacity: 1, stagger: 0.015, ease: 'none', scrollTrigger: { trigger: ref.current, start: 'top 70%', end: 'bottom 60%', scrub: true } }
    );
  }, []);

  return (
    <section ref={ref} className="border-t border-line pb-16 pt-12 md:pb-24 md:pt-16">
      <div className="container-x">
        <p className="display-md max-w-[28ch] font-medium leading-[1.15]">
          {TEXT.split(' ').map((w, i) => (
            <span key={i} data-word className="inline-block">{w}&nbsp;</span>
          ))}
        </p>
      </div>
      <div className="mt-12 border-y border-line py-5">
        <Marquee speed={36}>
          {OWN.map((p) => (
            <span key={p.name} className="mx-8 font-display text-4xl font-normal tracking-tight text-cream/70 md:mx-12 md:text-6xl">
              {p.name}
            </span>
          ))}
        </Marquee>
        <ul className="sr-only">
          {OWN.map((p) => (
            <li key={p.name}>
              {p.to ? <Link to={p.to}>{p.name}</Link> : <a href={p.href}>{p.name}</a>}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
